// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;width:100%;height:100%}.el-dialog__footer,.el-dialog__header{background-color:#f2f2f2}.el-dialog__body{border-top:3px solid #009688;border-bottom:3px solid #009688}", ""]);
// Exports
module.exports = exports;
